import { render, staticRenderFns } from "./BaseScrollbar.vue?vue&type=template&id=6927aef8&"
import script from "./BaseScrollbar.vue?vue&type=script&lang=js&"
export * from "./BaseScrollbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports